var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.showLocationDialog,
            callback: function($$v) {
              _vm.showLocationDialog = $$v
            },
            expression: "showLocationDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("span", { staticClass: "title mb-3" }, [
                    _vm._v("Select location")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-radio-group",
                        {
                          model: {
                            value: _vm.locationGroup,
                            callback: function($$v) {
                              _vm.locationGroup = $$v
                            },
                            expression: "locationGroup"
                          }
                        },
                        _vm._l(_vm.locations, function(option) {
                          return _c("v-radio", {
                            key: option.place_id,
                            attrs: {
                              label: option.formatted_address,
                              value: option
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent" },
                          on: { click: _vm.acceptLocation }
                        },
                        [_vm._v("Accept")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showLocationDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showMapSmall || !_vm.$vuetify.breakpoint.xsOnly
        ? _c(
            "GmapMap",
            {
              ref: "mapRef",
              style: _vm.styles,
              attrs: {
                center: _vm.mapCenter,
                zoom: _vm.mapZoomLevel,
                options: _vm.mapOptions,
                "map-type-id": "roadmap"
              },
              on: { click: _vm.onMapClick },
              nativeOn: {
                dblclick: function($event) {
                  return _vm.handleDbClick.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "gmap-info-window",
                {
                  attrs: {
                    options: _vm.infoOptions,
                    position: _vm.infoWindowPos,
                    opened: _vm.infoWinOpen
                  },
                  on: {
                    closeclick: function($event) {
                      return _vm.closeClick()
                    }
                  }
                },
                [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.infoContent) }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "gmap-info-window",
                {
                  attrs: {
                    options: _vm.infoOptions,
                    position: _vm.locationWindowPos,
                    opened: _vm.locationInfoWinOpen
                  },
                  on: {
                    closeclick: function($event) {
                      return _vm.closeLocationInfoWin()
                    }
                  }
                },
                [
                  _vm.selectedLocation
                    ? _c(
                        "v-layout",
                        { staticClass: "ma-2", attrs: { column: "" } },
                        [
                          _c("h3", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.selectedLocation.chute.label) +
                                "\n          "
                            ),
                            _c("i", [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.selectedLocation.chute.companyName
                                  ) +
                                  ")"
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-btn",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.setOrigin()
                                }
                              }
                            },
                            [_vm._v("Origin location")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-btn",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.setDestination()
                                }
                              }
                            },
                            [_vm._v("Destination location")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showLocationChutes && !_vm.singleValue
                ? _c(
                    "gmap-cluster",
                    { attrs: { zoomOnClick: "", imagePath: "/static/m" } },
                    _vm._l(_vm.loadingLocations, function(location, index) {
                      return _vm._.get(_vm.originMarker, "place_id", null) !==
                        location.googlePlace.placeId &&
                        _vm._.get(_vm.destinationMarker, "place_id", null) !==
                          location.googlePlace.placeId
                        ? _c("GmapMarker", {
                            key: "location_" + index,
                            attrs: {
                              icon: "/static/location-pin25.png",
                              position: {
                                lat: location.googlePlace.lat,
                                lng: location.googlePlace.lng
                              },
                              clickable: true,
                              draggable: false
                            },
                            on: {
                              click: function($event) {
                                return _vm.locationClick(location)
                              }
                            }
                          })
                        : _vm._e()
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.valueMarker
                ? _c("GmapMarker", {
                    attrs: {
                      icon: "/static/origin-icon.png",
                      position: _vm.valueMarker,
                      clickable: true,
                      draggable: true
                    },
                    on: { dragend: _vm.onDragValue }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.originMarker
                ? _c("GmapMarker", {
                    attrs: {
                      icon: "/static/origin-icon.png",
                      position: _vm.originMarker,
                      clickable: true,
                      draggable: _vm.editPosition
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleInfoWindow(
                          _vm.originMarker,
                          _vm.originNameText,
                          1
                        )
                      },
                      dragend: _vm.onDragOrigin
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.destinationMarker
                ? _c("GmapMarker", {
                    attrs: {
                      icon: "/static/destination-icon.png",
                      position: _vm.destinationMarker,
                      clickable: true,
                      draggable: _vm.editPosition
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleInfoWindow(
                          _vm.destinationMarker,
                          _vm.destinationNameText,
                          2
                        )
                      },
                      dragend: _vm.onDragDestination
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.positionMarkers, function(positionMarker, idx) {
                return _vm.positionMarkers
                  ? _c("GmapMarker", {
                      key: "markerId_" + idx,
                      attrs: {
                        icon: "/static/been-here-marker.png",
                        position: positionMarker,
                        clickable: true,
                        draggable: false
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleInfoWindow(
                            positionMarker,
                            positionMarker.infoText,
                            "pos_" + idx
                          )
                        }
                      }
                    })
                  : _vm._e()
              })
            ],
            2
          )
        : _c(
            "v-layout",
            { attrs: { "align-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-0",
                      attrs: { depressed: "", small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.showMapSmall = true
                        }
                      }
                    },
                    [_vm._v("\n        Show Map\n      ")]
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _vm.loading && !_vm.singleValue
        ? _c("v-progress-linear", {
            staticClass: "mt-0",
            attrs: { indeterminate: true }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "pa-0" },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        [
                          _c("v-text-field", {
                            attrs: { type: "number", label: "Latitude" },
                            model: {
                              value: _vm.searchLat,
                              callback: function($$v) {
                                _vm.searchLat = _vm._n($$v)
                              },
                              expression: "searchLat"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "ml-3" },
                        [
                          _c(
                            "v-text-field",
                            {
                              attrs: { type: "number", label: "Longitude" },
                              model: {
                                value: _vm.searchLng,
                                callback: function($$v) {
                                  _vm.searchLng = _vm._n($$v)
                                },
                                expression: "searchLng"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-0",
                                  attrs: {
                                    slot: "append-outer",
                                    flat: "",
                                    icon: "",
                                    color: "accent",
                                    disabled: !_vm.searchLat || !_vm.searchLng
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.centerLocation()
                                    }
                                  },
                                  slot: "append-outer"
                                },
                                [_c("v-icon", [_vm._v("my_location")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.singleValue
                ? _c(
                    "v-flex",
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "align-center": "",
                            "justify-end": "",
                            row: "",
                            "fill-height": ""
                          }
                        },
                        [
                          _vm.loading
                            ? _c("i", { staticClass: "text-no-wrap" }, [
                                _vm._v(
                                  "Loading " +
                                    _vm._s(
                                      _vm.$tc("company-profile.load-chutes", 2)
                                    ) +
                                    "..."
                                )
                              ])
                            : [
                                _vm.showLocationChutes
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          right: "",
                                          flat: "",
                                          color: "accent"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.showLocationChutes = false
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Hide " +
                                            _vm._s(
                                              _vm.$t(
                                                "company-profile.load-chute"
                                              )
                                            ) +
                                            " locations\n            "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          right: "",
                                          flat: "",
                                          color: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.showLocationChutes = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Show " +
                                            _vm._s(
                                              _vm.$t(
                                                "company-profile.load-chute"
                                              )
                                            ) +
                                            " locations\n            "
                                        )
                                      ]
                                    )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ada724d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ada724d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadMap.vue
// module id = null
// module chunks = 